import { h } from "preact";
import { Card, Button, Image } from "semantic-ui-react";

const UserCard = ({
  user,
  isCurrentUser,
  settingIsManager,
  setManagerRole,
}) => (
  <Card>
    <Card.Content>
      <Image floated="right" size="mini" src={user.picture_url} />
      <Card.Header>{user.first_name + " " + user.last_name}</Card.Header>
      {isCurrentUser && <Card.Meta>This is you!</Card.Meta>}
    </Card.Content>
    <Card.Content extra>
      <div className="ui two buttons">
        {settingIsManager ? (
          <Button basic disabled loading>
            Setting Manager state
          </Button>
        ) : user.is_manager ? (
          <Button
            disabled={isCurrentUser}
            basic
            color="red"
            onClick={() => setManagerRole(user, false)}
          >
            Revoke Manager privileges
          </Button>
        ) : (
          <Button
            basic
            color="green"
            onClick={() => setManagerRole(user, true)}
          >
            Make manager
          </Button>
        )}
      </div>
    </Card.Content>
  </Card>
);

export default UserCard;



// WEBPACK FOOTER //
// ./src/modules/manager/components/UserCard.js